exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MyCourses-module__top___1SYtB{display:grid;justify-content:start;gap:1rem;margin-bottom:2rem}@media screen and (min-width:525px){.MyCourses-module__top___1SYtB{grid-auto-flow:column}}.MyCourses-module__page-wrapper___3RSV9,.MyCourses-module__wrapper___3Wc19{display:grid;gap:1.5rem}.MyCourses-module__wrapper___3Wc19{grid-template-columns:repeat(auto-fill,minmax(225px,1fr))}", ""]);

// exports
exports.locals = {
	"top": "MyCourses-module__top___1SYtB",
	"page-wrapper": "MyCourses-module__page-wrapper___3RSV9",
	"wrapper": "MyCourses-module__wrapper___3Wc19"
};